export { default as Hero } from './hero/hero';
export { default as WhyDomain } from './why-domain/why-domain';
export { default as SpeakToAgent } from './speak-to-agent/speak-to-agent';
export { default as DomainForOwners } from './domain-for-owners/domain-for-owners';
export { default as SellingGuide } from './selling-guide/selling-guide';
export { default as Footer } from './footer/footer';
export { default as Link } from './link/link';
